export enum PlanCategory {
  Business = 'business',
  Creator = 'creator',
  CreatorPro = 'creator_pro',
  Enterprise = 'enterprise',
  Starter = 'starter',
}

export enum PaymentInterval {
  Month = 'month',
  Year = 'year',
}

export enum SubscriptionStatus {
  Active = 'active',
  Canceled = 'canceled',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  // PastDue — первое неудачное списание с карты юзера.
  // страйп делает попытки списать деньги с юзера
  PastDue = 'past_due',
  Paused = 'paused',
  // Статусы Trialing, Incomplete, IncompleteExpired приравниваются к статусу Active
  Trialing = 'trialing',
  // Unpaid — страйп перестает делать попытки списать деньги с карты юзера
  Unpaid = 'unpaid',
}

export type Price = {
  id: string;
  recurring: {
    interval: PaymentInterval;
    interval_count: number;
    trial_period_days: null | number;
  } | null;
  currency: string;
  experiment_variant?: 'D' | null;
  status: 'active' | 'archived';
  unit_amount: number;
};

export enum BoosterType {
  SRT = 'srt',
  TeamspaceSeat = 'teamspace_seat',
  TranslationPrompting = 'translation_prompting',
}

type Metadata = {
  label: null | string;
  booster_type?: BoosterType | null;
  bundle_position: number;
  bundle_value: number | string;
  bundle_value_default: boolean;
  extra_minutes_price: null | number | string;
  highlighted_button: null | string;
  position: number;
};

export type Plan = {
  id: string;
  name: string;
  boosters_to_remove?: BoosterType[];
  bundles: null | Plan[];
  category: PlanCategory;
  description: string;
  is_archived: boolean;
  metadata: Metadata;
  minutes_to_add: null | number;
  prices: Price[];
};

export type TCurrentPlan = {
  id: Price['id'];
  amount: Price['unit_amount'];
  currency: Price['currency'];
  interval: PaymentInterval;
  product_id: Plan['id'];
};

export type BoosterData = {
  expiration: string;
  product_id: string;
  quantity: number;
};

export type UserBoosters = Partial<Record<BoosterType, BoosterData>>;

export type ScheduleInfoItem = {
  current_product_id: string;
  current_quantity: number;
  new_product_id: null | string;
  new_quantity: null | number;
  update_date: string;
};

export type ScheduleInfo = {
  boosters: ScheduleInfoItem[];
  plan: null | ScheduleInfoItem;
};

export type Subscription = {
  id: string;
  credits: {
    minutes: number;
  };
  boosters: null | UserBoosters;
  current_period_end: string;
  current_period_start: string;
  payments_collection_paused: boolean;
  payments_collection_paused_until: null | string;
  plan: TCurrentPlan;
  schedule_info: null | ScheduleInfo;
  status: SubscriptionStatus;
  user_id: string;
  cancel_at_period_end: boolean;
  created: string;
};

export type TCredit = Omit<Plan, 'bundles'>;

export type Products = {
  pricing_experiment?: {
    eligible: boolean;
    key: string;
    started_at: null | string;
    variant: 'C' | 'D' | null;
  };
  boosters: Plan[];
  credit: TCredit[];
  plan: Plan[];
};

export enum PromoDuration {
  Forever = 'forever',
  Once = 'once',
  Repeating = 'repeating',
}
